// rate-limit.interceptor.ts (actualizado)
import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse
} from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { RateLimitService } from '../shared/services/rate-limit.service';
import { UtilitarioService } from '../service/utilitarios/utilitario.service';

@Injectable()
export class RateLimitInterceptor implements HttpInterceptor {
  constructor(private rateLimitService: RateLimitService,
    private utilitarioService: UtilitarioService

  ) {}

intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  const state = this.rateLimitService.getCurrentState();

  // Si ya hay bloqueo activo, cancelar la petición inmediatamente
  if (state.isActive) {
    // console.log('[RateLimitInterceptor] Bloqueo activo. Cancelando petición a', req.url);
    this.utilitarioService.loading = false;
    return EMPTY;
  }

  return next.handle(req).pipe(
    catchError((err: any) => {
// dentro de catchError(...)
if (err instanceof HttpErrorResponse && err.status === 429) {
    this.utilitarioService.loading = false;
  const headerRetry = err.headers?.get ? err.headers.get('Retry-After') : null;

  // body puede contener retryAfterSeconds (tu caso) o retryAfter (otros backends).
  const body = err.error ?? {};
  const retryFromBody = (typeof body.retryAfterSeconds !== 'undefined')
    ? Number(body.retryAfterSeconds)
    : (typeof body.retryAfter !== 'undefined' ? Number(body.retryAfter) : null);

  // Retry-After header puede ser un número (segundos) o una fecha HTTP.
  let retryAfter = null;
  if (headerRetry) {
    const headerNum = parseInt(headerRetry, 10);
    if (!isNaN(headerNum)) {
      retryAfter = headerNum;
    } else {
      // si viene fecha HTTP, convertir a segundos restantes
      const date = new Date(headerRetry);
      if (!isNaN(date.getTime())) {
        const secs = Math.ceil((date.getTime() - Date.now()) / 1000);
        retryAfter = secs > 0 ? secs : 0;
      }
    }
  }

  // Prioridad: header > body.retryAfterSeconds > body.retryAfter > default(10)
  retryAfter = (retryAfter !== null && !isNaN(retryAfter)) ? retryAfter :
               (retryFromBody !== null && !isNaN(retryFromBody)) ? Math.floor(retryFromBody) :
               10;

  const blockId = (err.headers && err.headers.get) ? err.headers.get('X-Block-Id') : (body.blockId ?? null);

  this.rateLimitService.markPendingBlock(retryAfter, blockId, req.url);
  this.rateLimitService.handle429({ retryAfterSeconds: retryAfter, blockId, endpoint: req.url });
  this.utilitarioService.loading = false;
}
        this.utilitarioService.loading = false;
      return throwError(() => err);
    })
  );
}

}
